import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson12: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center p-[2.69rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV />
      <div className="self-stretch flex flex-row items-center justify-between">
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson11"}>
          <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Back
            </b>
          </div>
        </a>
        <div className="flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[120%]">Trading Safety</b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson13"}>
          <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Next
            </b>
          </div>
        </a>
      </div>
      <div className="flex flex-col items-center justify-center gap-[9.63rem] w-[92%] mr-[4%] max-w-[110rem] text-justify text-[1.88rem] text-white font-dm-sans">
        <div className="self-stretch flex flex-row items-center justify-center gap-[7rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Cryptocurrency Security</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Security is one of the most significant challenges that any
                  cryptocurrency user encounters.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  This Safety Guide aims to assist all Secured members in better
                  safeguarding their crypto assets.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[29.63rem] h-[22.22rem] object-cover"
            alt=""
            src="/i51@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1rem] text-gainsboro-100">
          <p className="m-0">
            <b className="text-[1.88rem] font-dm-sans">
              <span className="text-white">
                The Importance of Crypto Security
              </span>
            </b>
          </p>
          <p className="m-0">
            <span>
              <b className="text-[1.88rem] font-dm-sans">&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  As cryptocurrencies have grown increasingly popular over the
                  past few years, exchanges dealing with them have been the prey
                  of many malicious attacks.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  BitGrail: $146m was hacked from the Italian exchange in 2018.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  KuCoin: $281m was stolen by suspected North Korean hackers
                  from this attack in 2020.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  KuCoin recovered most of the funds and refunded customers.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  MtGox: $450m of mainly Bitcoin was hacked in 2014 which
                  collapsed the Japanese exchange.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Coincheck: $534m was stolen in 2018 from the Japanese
                  exchange. Customers were eventually reimbursed.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  $610m was hacked from the Chinese exchange on August 21, 2021.
                  The hacker returned all the funds and customers have started
                  being reimbursed.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Even as exchanges up their security, these cyberattacks are
                  becoming more sophisticated too.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>About 5 million BTC is probably lost forever.</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  This is a result of owners losing their private keys
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>{`Crypto investors lost over `}</span>
              </span>
              <a
                className="text-[inherit]"
                href="https://www.cnbc.com/2021/11/19/over-10-billion-lost-to-defi-scams-and-thefts-in-2021.html"
                target="_blank"
              >
                <span>
                  <span>
                    <span className="[text-decoration:underline]">
                      $10 Billion
                    </span>
                  </span>
                </span>
              </a>
              <span>
                <span> to various crypto scams and thefts</span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Criminal Activity</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  As stated above cybercriminals are becoming more sophisticated
                  with their strategies and methods using some of the most
                  advanced tech solutions
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Here are some common ways these scammers can steal from crypto
                  investors:
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Phishing - They create fake websites that look like the sites
                  of some service providers you use. You enter your data there,
                  and scammers apply it to steal your coins
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Hijacking your live session - If you use a Wi-Fi hotspot in a
                  public place and access your sensitive crypto information you
                  are in danger. Your sensitive info can be hacked into without
                  implementing advanced technology.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Scam ICOs - Nowadays scammers can easily start an ICO, run a
                  huge promo campaign for it, and get investors to buy their
                  tokens with BTC. They have plenty of incentives to entice
                  investors like referral programs, etc. Once they get enough
                  money they close up shop with your money leaving no trace
                  behind.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Ransomware - It encrypts files on your computer and then
                  demands BTC ransom for the decryption key
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Hacking into exchanges and other places storing big amounts of
                  cryptocurrency - Any large exchange is a goldmine in
                  attracting hackers. It may be difficult to bypass its security
                  system, but the reward is huge. With so much new exchanges
                  popping up, their level of security can pose a big risk. These
                  hackers will not show any remorse.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Forex Scams - Scammers persuade people to invest their money
                  into a win-win schemes promising quick gains and returns.
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  Cryptojacking - Hackers can use an advanced type of malware to
                  use the computing power of your PC for mining cryptocurrency.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[13.38rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Do Not Ignore Safety Measures</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <ul className="m-0 text-[1rem] pl-[2.06rem]">
              <li>
                <span>
                  <span>
                    Keeping your crypto assets safe is completely your
                    responsibility! Many new crypto investors are probably used
                    to a centralized institution like a bank providing that
                    security for them. As a result of that, it can be easy to
                    ignore basic cryptocurrency safety measures. Key crypto
                    safety measures you should always remember to practice:
                  </span>
                </span>
              </li>
            </ul>
          </div>
          <img
            className="relative w-[30.13rem] h-[30.13rem] object-cover"
            alt=""
            src="/i52@2x.png"
          />
        </div>
        <img
          className="relative w-[0.36rem] h-[0.16rem] object-cover"
          alt=""
          src="/vector-5@2x.png"
        />
        <div className="self-stretch flex flex-row items-center justify-center gap-[2.5rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Final Takeaway</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <ul className="m-0 text-[1rem] pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Being in a decentralized system like cryptocurrencies,
                    security measures are solely up to individual users. It may
                    seem strenuous and time-intensive but we guarantee it will
                    be worth it in the long run practicing safeguarding your
                    crypto assets.
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <ul className="m-0 text-[1.56rem] pl-[2.06rem]">
              <li>
                <span>
                  <span>
                    In the crypto world news is very important, make sure you
                    are constantly staying up to date. This way you will be
                    aware of any new threats or problems as they occur as well
                    as possible solutions to avoid them.
                  </span>
                </span>
              </li>
            </ul>
          </div>
          <img
            className="relative w-[47.31rem] h-[26.61rem] object-cover"
            alt=""
            src="/i53@2x.png"
          />
        </div>
      </div>
      <a className="w-full mb-[6rem] rounded-32xl bg-gainsboro-200 box-border flex flex-row items-center justify-between py-[0.75rem] px-[0rem] max-w-[25rem] text-center text-[2.81rem] border-[1px] border-solid border-gray-300"
        href="/lesson13">
        <div className="w-full">
          <b className="inline-block flex-1 w-full relative text-center pb-[0.8rem]">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson12;
